import { History } from 'history';
import dataSourceKind from '../../../../infrastructure/constants/dataSourceKind';
import IngestionConfig from '../../../../types/ingestion/IngestionConfig';
import typeHelper from '../../../../infrastructure/helpers/common/typeHelper';
import IngestionMode from '../../../../types/ingestion/IngestionMode';
import CsvIngestionArguments from '../../../../types/ingestion/csv/CsvIngestionArguments';

const getIngestionConfig = (history: History<any>): IngestionConfig => {

    return typeHelper.isObject(history.location.state) ? history.location.state : getEmptyIngestionConfig();
};

const getEmptyCsvSeparator = (): CsvIngestionArguments => {
    return {
        separator: '',
        textSeparator: null,
        headerLineNumber: 0,
        dataLineNumber: null as any,
        escapeCharacter: '"'
    };
}

const getEmptyIngestionConfig = (): IngestionConfig => {
    return {
        id: null,
        name: '',
        filenames: '',
        xmlSectionName: '',
        jsonSectionName: '',
        description: '',
        emptyValueTokens: '',
        isTransposed: null,
        dataSourceKind: dataSourceKind.raw,
        fileType: '',
        fieldDefinitions: [],
        csvSpecification: getEmptyCsvSeparator(),
        version: null as any,
        reportConfigs: [],
        ingestionMode: IngestionMode.Flexible,
    };
};

export {
    getIngestionConfig,
    getEmptyIngestionConfig,
    getEmptyCsvSeparator
};
